export default [
    {
        path: '/pages/admin/contractTypeManage',
        name: '/pages/admin/contractTypeManage',
        component: () => import('@/views/contract/contractTypeManageList.vue')
    },
    {
        path: '/views/contract/contractTypeSpecManage',
        name: '/views/contract/contractTypeSpecManage',
        component: () => import('@/views/contract/contractTypeSpecManageList.vue')
    },
    {
        path: '/pages/admin/contractPartyaManage',
        name: '/pages/admin/contractPartyaManage',
        component: () => import('@/views/contract/contractPartyaManageList.vue')
    },
    {
        path: '/pages/admin/newContractManage',
        name: '/pages/admin/newContractManage',
        component: () => import('@/views/contract/newContractManageList.vue')
    },
    {
        path: '/pages/admin/queryArrearsContract',
        name: '/pages/admin/queryArrearsContract',
        component: () => import('@/views/contract/queryArrearsContractList.vue')
    },
    {
        path: '/pages/admin/file',
        name: '/pages/admin/file',
        component: () => import('@/views/contract/file.vue')
    },
    {
        path: '/pages/admin/operationLog',
        name: '/pages/admin/operationLog',
        component: () => import('@/views/contract/operationLogList.vue')
    },
    {
        path: '/pages/admin/partyContract',
        name: '/pages/admin/partyContract',
        component: () => import('@/views/contract/partyContract.vue')
    },
    {
        path: '/pages/admin/virtualContract',
        name: '/pages/admin/virtualContract',
        component: () => import('@/views/contract/virtualContract.vue')
    },
    {
        path: '/pages/admin/courseScheduleDisplay',
        name: '/pages/admin/courseScheduleDisplay',
        component: () => import('@/views/contract/courseScheduleDisplay.vue')
    },
    {
        path: '/pages/admin/courseScheduleDisplayVip',
        name: '/pages/admin/courseScheduleDisplayVip',
        component: () => import('@/views/contract/courseScheduleDisplayVip.vue')
    },
    {
        path: '/pages/admin/courseScheduleManage',
        name: '/pages/admin/courseScheduleManage',
        component: () => import('@/views/contract/courseScheduleManage.vue')
    },
    {
        path: '/pages/admin/courseScheduleManageVip',
        name: '/pages/admin/courseScheduleManageVip',
        component: () => import('@/views/contract/courseScheduleManageVip.vue')
    },
    {
        path: '/views/contract/addContract',
        name: '/views/contract/addContract',
        component: () => import('@/views/contract/addContractList.vue')
    },
    {
        path: '/pages/admin/contractManage',
        name: '/pages/admin/contractManage',
        component: () => import('@/views/contract/contractManageList.vue')
    },
    {
        path: '/pages/admin/contractChangeManage',
        name: '/pages/admin/contractChangeManage',
        component: () => import('@/views/contract/contractChangeManageList.vue')
    },
    {
        path: '/views/contract/contractChangeDetail',
        name: '/views/contract/contractChangeDetail',
        component: () => import('@/views/contract/contractChangeDetailList.vue')
    },
    {
        path: '/pages/admin/expirationContractManage',
        name: '/pages/admin/expirationContractManage',
        component: () => import('@/views/contract/expirationContractManageList.vue')
    },
    {
        path: '/views/contract/contractDetail',
        name: '/views/contract/contractDetail',
        component: () => import('@/views/contract/contractDetail.vue')
    },
    {
        path: '/views/contract/contractChangeDetails',
        name: '/views/contract/contractChangeDetails',
        component: () => import('@/views/contract/contractChangeDetailsList.vue')
    },
    {
        path: '/pages/admin/contractApplyAuditOrders',
        name: '/pages/admin/contractApplyAuditOrders',
        component: () => import('@/views/contract/contractApplyAuditOrdersList.vue')
    },
    {
        path: '/pages/admin/contractChangeAuditOrders',
        name: '/pages/admin/contractChangeAuditOrders',
        component: () => import('@/views/contract/contractChangeAuditOrdersList.vue')
    },
    {
        path: '/pages/admin/contractApplyAuditHistoryOrders',
        name: '/pages/admin/contractApplyAuditHistoryOrders',
        component: () => import('@/views/contract/contractApplyAuditHistoryOrdersList.vue')
    },
    {
        path: '/pages/admin/contractChangeAuditHistoryOrders',
        name: '/pages/admin/contractChangeAuditHistoryOrders',
        component: () => import('@/views/contract/contractChangeAuditHistoryOrdersList.vue')
    },
]